var loadRemoteResource = require('../reader/load-remote-resource');

function fetchFrom(callback) {
  return callback || loadRemoteResource;
}

module.exports = fetchFrom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/options/fetch.js
// module id = 1023
// module chunks = 0